import styled from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

export const Container = styled.div`
  ${mediaQueries.laptop} {
    max-width: 224px;
  }
`
